<template>
  <div class="d-flex">
    <v-icon :icon="icon" :class="iconClass" />
    <span :class="textClass">
      {{ text }}
    </span>
  </div>
</template>

<script setup lang="ts">

export interface Props {
  icon?: string,
  iconClass?: string,
  text?: string,
  textClass?: string
}

withDefaults(defineProps<Props>(), {
  icon: 'mdi-forum',
  iconClass: 'mr-8',
  text: 'Chat With Us',
  textClass: '',
})

const authStore = useAuthStore()
const user = authStore.user!

const launchFreshChat = () => initialize(document, 'freshchat-js-sdk')
const open = () => {
  (window as any).fcWidget?.open()
}
const close = () => {
  (window as any).fcWidget?.close()
}

const config = useRuntimeConfig()
const initFreshChat = () => {
  (window as any).fcWidget?.init({
    token: config.public.FRESHDESK_API_KEY,
    host: 'https://wchat.freshchat.com',
    tags: ['in_app_support', 'suggestions'],
    externalId: user.id,
    firstName: user.first_name,
    lastName: user.last_name,
    email: user.email,
    phone: user.phone,
    phoneCountryCode: '+1',
    company: user.company,
    company_jobtitle: user.company_jobtitle,
    config: {
      headerProperty: {
        hideChatButton: true,
      },
    },
  })
}

const initialize = (i: Document, t: string) => { // function by freshchat
  if (i.getElementById(t)) {
    initFreshChat()
  }
  else {
    const e = i.createElement('script')
    e.id = '_1'
    e.async = !0
    e.src = 'https://wchat.freshchat.com/js/widget.js'
    e.onload = initFreshChat
    i.head.appendChild(e)
  }

  window.addEventListener('load', initFreshChat, !1)
}

onMounted(launchFreshChat)

defineExpose({
  close,
  open
})
</script>
